import React, { useEffect, useState } from 'react';
import { EditorModes, FormatterModes } from '../../../../code/interfaces/editor';
import { DESTINATION_TYPES } from '../../../../containers/destination/constants/destinationTypes';
import { RefreshService } from '../../../../core/services/refresh.service';
import useService from '../../../../injector/hooks/useService';
import { SchemaExplorerTreeProps } from '../../interfaces/schemaExplorer';
import { SchemaExplorerFolder } from '../schema-explorer-folder/SchemaExplorerFolder';
import {
  SchemaExplorerFolder as SchemaExplorerFolderInterface,
  SchemaResourceType
} from '../../interfaces/schemaExplorerFolder';

function SchemaExplorerTree({
  folders,
  source,
  onFolderDelete,
  onFolderToggle,
  schemaExplorerUIOptions,
  canShowViews
}: SchemaExplorerTreeProps) {
  const [filteredFolders, setFilteredFoldersList] = useState<SchemaExplorerFolderInterface[]>([]);
  const refreshService = useService(RefreshService);

  useEffect(() => {
    const { editorMode, formatterMode, queryFormattingDisabled } = DESTINATION_TYPES[source.dest_type];

    refreshService.sqlCodeEditorHintOptions(
      editorMode || EditorModes.SQL,
      formatterMode || FormatterModes.SQL,
      !queryFormattingDisabled
    );
  }, []);

  useEffect(() => {
    let foldersList = folders;
    if (!canShowViews) {
      foldersList = folders.filter(folder => folder.resourceType === SchemaResourceType.TABLE);
    }
    setFilteredFoldersList(foldersList);
  }, [canShowViews, folders]);

  return (
    <>
      {filteredFolders.map((folder, folderIndex) => (
        <SchemaExplorerFolder
          key={folder.id}
          folder={folder}
          source={source}
          onFolderDelete={onFolderDelete}
          onFolderToggle={collapsed => onFolderToggle(collapsed, folderIndex)}
          schemaExplorerUIOptions={schemaExplorerUIOptions}
        />
      ))}
    </>
  );
}

export default SchemaExplorerTree;
